import React from 'react';
import AssemblyReservationTreeSpace from './AssemblyReservationTreeSpace';
import { AssemblyTreeProvider } from './AssemblyTreeContext';

const AssemblyReservationTreeSpaceWithContext = () => {
  return (
    <AssemblyTreeProvider>
      <AssemblyReservationTreeSpace />
    </AssemblyTreeProvider>
  );
};

export default AssemblyReservationTreeSpaceWithContext;
